import { Component, inject, input } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Location } from '../../../../../api/models/location';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-feature-hint',
    imports: [
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatIcon,
        TranslateModule,
        NgClass,
    ],
    templateUrl: './feature-hint.component.html',
    styleUrl: './feature-hint.component.scss',
})
export class FeatureHintComponent {
    private sessionService = inject(SessionService);

    featureType = input.required<FeatureType>();
    isTooltipContent = input(false);

    getEmailTemplate(featureName: string): string {
        return (
            '?subject=' +
            encodeURIComponent(`Request for Feature ${featureName}`) +
            '&body=' +
            encodeURIComponent(`Hello,

        I would like to request the Feature "${featureName}" for my organisation.

        Organisation: ${this.sessionService.getSession()?.organizations[0].name || 'N/A'}
        Address: ${this.getLocationStr(this.sessionService.getSession()?.organizations[0].location) || 'N/A'}
        GLN: ${this.sessionService.getSession()?.organizations[0].gln || 'N/A'}

        Best Regards`)
        );
    }

    private getLocationStr(loc: Location | undefined): string | undefined {
        if (!loc) {
            return undefined;
        }
        return `${loc.country}, ${loc.zipCode}, ${loc.city}, ${loc.street}`;
    }
}
export enum FeatureType {
    ASN = 'ADVANCED_SHIPPING_NOTICE',
    BUNDLE_GROUPING = 'BUNDLE_GROUPING',
    CONSIGNEE_ARTICLE_DISCREPANCIES = 'CONSIGNEE_ARTICLE_DISCREPANCIES',
    CONSIGNEE_ARTICLES_EDITING = 'CONSIGNEE_ARTICLES_EDITING',
    CONSIGNEE_ARTICLES_READ = 'CONSIGNEE_ARTICLES_READ',
    CONSIGNEE_SHOW_ITEM_QRCODE = 'CONSIGNEE_SHOW_ITEM_QRCODE',
    CSV_REPORTING = 'CSV_REPORTING',
    ECMR = 'ECMR',
    MONTHLY_DELIVERY_NOTE_REPORT = 'MONTHLY_DELIVERY_NOTE_REPORT',
    GENERAL_GUI_FEATURES = 'GENERAL_GUI_FEATURES',
}
